import moment from 'moment';
import React from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import FontAwesome from '@react-native-vector-icons/fontawesome';
import { RootState } from '../redux/store';
import { useSelector } from 'react-redux';
import { useGetPendingAuthorizationsQuery } from '../redux/services/foauthorizationApi';
import { useGetANotificationsByUserQuery } from '../redux/services/anotificationsApi';

const Header = ({
  onMenuPress,
  onBackPress,
  onNotificationPress,
  onLogoutPress,
  showBack = false,
}: {
  onMenuPress?: () => void;
  onBackPress?: () => void;
  onNotificationPress?: () => void;
  onLogoutPress?: () => void;
  showBack?: boolean;
}) => {
  const gdata = useSelector((state: RootState) => state.gdata);

  const hasFOAccess = gdata.menu?.some(
    (v: any) => v.mn_link === '/status/status' || v.mn_link === '/admin/company'
  );
  const hasAuthPermission =
    hasFOAccess ||
    gdata.menu?.some(
      (v: any) => v.mn_link === '/admin/pending-authorizations'
    );

  const { data: pendingAuths = [] } = useGetPendingAuthorizationsQuery(
    undefined,
    { skip: !hasAuthPermission }
  );
  const { data: notifications = [] } = useGetANotificationsByUserQuery(
    undefined,
    { skip: !gdata.user }
  );

  const pendingAuthCount = Array.isArray(pendingAuths) ? pendingAuths.length : 0;
  const unreadNotifCount = Array.isArray(notifications)
    ? notifications.filter((n: any) => n.nt_isread !== '1').length
    : 0;
  const totalCount = pendingAuthCount + unreadNotifCount;

  return (
    <View style={styles.header}>
      <View style={styles.leftIcons}>
        {showBack && onBackPress && (
          <TouchableOpacity
            onPress={onBackPress}
            style={styles.iconButton}
            hitSlop={{top: 10, bottom: 10, left: 10, right: 10}}>
            <FontAwesome name="arrow-left" size={20} color="#000" />
          </TouchableOpacity>
        )}
        {onMenuPress && (
          <TouchableOpacity onPress={onMenuPress} style={styles.iconButton}>
            <FontAwesome name="bars" size={20} color="#000" />
          </TouchableOpacity>
        )}
      </View>

      <View style={styles.titleContainer}>
        <Text style={styles.title}>{gdata.companyname.substring(0, 20)}</Text>
        <Text style={styles.date}>
          {moment(gdata.today).format('ddd DD-MM-YYYY')}
        </Text>
      </View>

      <View style={styles.rightIcons}>
        <TouchableOpacity
          onPress={onNotificationPress}
          style={styles.iconButton}>
          <FontAwesome name="bell" size={20} color="#000" />
          {totalCount > 0 && (
            <View style={styles.badge}>
              <Text style={styles.badgeText}>
                {totalCount > 99 ? '99+' : totalCount}
              </Text>
            </View>
          )}
        </TouchableOpacity>
        <TouchableOpacity onPress={onLogoutPress} style={styles.iconButton}>
          <FontAwesome name="sign-out" size={20} color="#000" />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    height: 56,
    backgroundColor: '#e9ecef',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderColor: '#ccc',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 20,
  },
  leftIcons: {
    flexDirection: 'row',
    gap: 12,
    alignItems: 'center',
  },
  titleContainer: {
    alignItems: 'center',
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  date: {
    fontSize: 12,
    color: '#333',
  },
  rightIcons: {
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
  },
  iconButton: {
    padding: 6,
    position: 'relative',
  },
  badge: {
    position: 'absolute',
    top: 0,
    right: -2,
    backgroundColor: '#EF4444',
    borderRadius: 9,
    minWidth: 17,
    height: 17,
    paddingHorizontal: 3,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1.5,
    borderColor: '#e9ecef',
  },
  badgeText: {
    color: '#FFFFFF',
    fontSize: 9,
    fontWeight: 'bold',
  },
});

export default Header;

